(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 699px)';
  var REDUCE_QUERY = '(prefers-reduced-motion: reduce)';
  var AUTOPLAY_DELAY = 5500;

  function initBenefitSlider(root) {
    if (!root) return;
    if (typeof root.__jwBenefitSliderDestroy === 'function') {
      root.__jwBenefitSliderDestroy();
    }

    var track = root.querySelector('[data-jw-benefit-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-jw-benefit-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-jw-benefit-dot]'));
    if (!track || slides.length < 2) return;

    var mobileQuery = window.matchMedia(MOBILE_QUERY);
    var reduceQuery = window.matchMedia(REDUCE_QUERY);
    var cleanups = [];
    var pauseReasons = new Set();
    var autoplayTimer = null;
    var resumeTimer = null;
    var scrollFrame = null;
    var activeIndex = 0;

    function listen(target, eventName, handler, options) {
      target.addEventListener(eventName, handler, options);
      cleanups.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    function clearAutoplay() {
      if (autoplayTimer !== null) {
        window.clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function canAutoplay() {
      return mobileQuery.matches &&
        !reduceQuery.matches &&
        !document.hidden &&
        pauseReasons.size === 0 &&
        root.isConnected;
    }

    function scheduleAutoplay() {
      clearAutoplay();
      if (!canAutoplay()) return;
      autoplayTimer = window.setTimeout(function () {
        autoplayTimer = null;
        goTo((activeIndex + 1) % slides.length, false);
        scheduleAutoplay();
      }, AUTOPLAY_DELAY);
    }

    function slidePosition(slide) {
      var trackRect = track.getBoundingClientRect();
      var slideRect = slide.getBoundingClientRect();
      return slideRect.left - trackRect.left + track.scrollLeft;
    }

    function updateCurrent(index) {
      activeIndex = Math.max(0, Math.min(slides.length - 1, index));
      dots.forEach(function (dot, dotIndex) {
        if (dotIndex === activeIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function goTo(index, fromUser) {
      if (!mobileQuery.matches) return;
      var nextIndex = (index + slides.length) % slides.length;
      updateCurrent(nextIndex);
      track.scrollTo({
        left: slidePosition(slides[nextIndex]),
        behavior: reduceQuery.matches ? 'auto' : 'smooth'
      });
      if (fromUser) restartAfterInteraction();
    }

    function syncCurrentToScroll() {
      scrollFrame = null;
      if (!mobileQuery.matches) return;
      var nearestIndex = 0;
      var nearestDistance = Infinity;
      slides.forEach(function (slide, index) {
        var distance = Math.abs(slidePosition(slide) - track.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });
      updateCurrent(nearestIndex);
    }

    function queueScrollSync() {
      if (scrollFrame !== null) return;
      scrollFrame = window.requestAnimationFrame(syncCurrentToScroll);
    }

    function pause(reason) {
      pauseReasons.add(reason);
      clearAutoplay();
    }

    function resume(reason) {
      pauseReasons.delete(reason);
      scheduleAutoplay();
    }

    function restartAfterInteraction() {
      pause('interaction');
      if (resumeTimer !== null) window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function () {
        resumeTimer = null;
        resume('interaction');
      }, 900);
    }

    function setMode() {
      clearAutoplay();
      if (mobileQuery.matches) {
        track.setAttribute('tabindex', '0');
        dots.forEach(function (dot) {
          dot.removeAttribute('aria-hidden');
          dot.removeAttribute('tabindex');
        });
        queueScrollSync();
        scheduleAutoplay();
      } else {
        activeIndex = 0;
        track.scrollTo({ left: 0, behavior: 'auto' });
        track.setAttribute('tabindex', '-1');
        dots.forEach(function (dot, index) {
          dot.setAttribute('aria-hidden', 'true');
          dot.setAttribute('tabindex', '-1');
          if (index === 0) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    dots.forEach(function (dot, index) {
      listen(dot, 'click', function () {
        goTo(index, true);
      });
    });

    listen(track, 'scroll', queueScrollSync, { passive: true });
    listen(track, 'keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goTo(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
    });
    listen(track, 'pointerdown', function () {
      pause('pointer');
    }, { passive: true });
    listen(track, 'pointerup', function () {
      resume('pointer');
      restartAfterInteraction();
    }, { passive: true });
    listen(track, 'pointercancel', function () {
      resume('pointer');
    }, { passive: true });
    listen(track, 'wheel', restartAfterInteraction, { passive: true });
    listen(root, 'pointerenter', function (event) {
      if (event.pointerType === 'mouse') pause('hover');
    });
    listen(root, 'pointerleave', function (event) {
      if (event.pointerType === 'mouse') resume('hover');
    });
    listen(root, 'focusin', function () {
      pause('focus');
    });
    listen(root, 'focusout', function (event) {
      if (!root.contains(event.relatedTarget)) resume('focus');
    });
    listen(document, 'visibilitychange', function () {
      if (document.hidden) pause('hidden');
      else resume('hidden');
    });

    var handleMobileChange = setMode;
    var handleReduceChange = scheduleAutoplay;
    if (mobileQuery.addEventListener) {
      listen(mobileQuery, 'change', handleMobileChange);
      listen(reduceQuery, 'change', handleReduceChange);
    } else {
      mobileQuery.addListener(handleMobileChange);
      reduceQuery.addListener(handleReduceChange);
      cleanups.push(function () {
        mobileQuery.removeListener(handleMobileChange);
        reduceQuery.removeListener(handleReduceChange);
      });
    }

    root.setAttribute('data-jw-benefit-slider-ready', 'true');
    root.__jwBenefitSliderDebug = {
      get activeIndex() { return activeIndex; },
      get autoplayTimerCount() { return autoplayTimer === null ? 0 : 1; },
      get isMobile() { return mobileQuery.matches; },
      get isPaused() { return pauseReasons.size > 0 || reduceQuery.matches || document.hidden; }
    };

    root.__jwBenefitSliderDestroy = function () {
      clearAutoplay();
      if (resumeTimer !== null) window.clearTimeout(resumeTimer);
      if (scrollFrame !== null) window.cancelAnimationFrame(scrollFrame);
      cleanups.forEach(function (cleanup) { cleanup(); });
      cleanups = [];
      root.removeAttribute('data-jw-benefit-slider-ready');
      root.__jwBenefitSliderDebug = null;
      root.__jwBenefitSliderDestroy = null;
    };

    setMode();
  }

  window.__jwInitBenefitSlider = initBenefitSlider;

  function initWithin(scope) {
    if (scope.matches && scope.matches('[data-jw-benefit-slider]')) {
      initBenefitSlider(scope);
    }
    Array.prototype.forEach.call(
      scope.querySelectorAll ? scope.querySelectorAll('[data-jw-benefit-slider]') : [],
      initBenefitSlider
    );
  }

  if (!window.__jwBenefitSliderEventsBound) {
    window.__jwBenefitSliderEventsBound = true;
    document.addEventListener('shopify:section:load', function (event) {
      initWithin(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var roots = event.target.querySelectorAll('[data-jw-benefit-slider]');
      Array.prototype.forEach.call(roots, function (root) {
        if (typeof root.__jwBenefitSliderDestroy === 'function') {
          root.__jwBenefitSliderDestroy();
        }
      });
    });
  }

  function boot() {
    initWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
